import { useEffect } from 'react'

/**
 * Initializes Heap once analytics consent is granted.
 *
 * `load` only exists on the stub defined by `public/static/heapInit.js`: once the
 * Heap library finishes downloading it replaces `globalThis.heap` with its real
 * API, which has no `load`. `appid` is set synchronously by the stub's `load`, so
 * it also covers the window while the library is still in flight.
 */
const useHeapInit = (analyticsConsentGranted: boolean): void => {
  useEffect(() => {
    const appId = process.env.NEXT_PUBLIC_HEAP_APP_ID

    if (!appId || !analyticsConsentGranted) {
      return
    }

    if (typeof globalThis.heap?.load !== 'function' || globalThis.heap.appid) {
      return
    }

    globalThis.heap.load(appId)
  }, [analyticsConsentGranted])
}

export default useHeapInit
